const DEFAULT_APP_URL = 'https://paddiq.app';
const DEFAULT_API_URL = 'http://localhost:3001';
const DEFAULT_SENTRY_DSN = 'https://5ba6bb82d75eca4cd779f608ad6547df@o4511775890800640.ingest.us.sentry.io/4511775997689856';

function normalizeUrl(value: string) {
  return value.replace(/\/+$/, '');
}

export function getAppUrl() {
  const runtime = window.__PADDIQ_CONFIG__?.appUrl?.trim();
  if (runtime && runtime.length > 0) {
    return normalizeUrl(runtime);
  }

  const configured = import.meta.env.VITE_APP_URL?.trim();
  if (configured && configured.length > 0) {
    return normalizeUrl(configured);
  }

  return DEFAULT_APP_URL;
}

export function getApiUrl() {
  const runtime = window.__PADDIQ_CONFIG__?.apiUrl?.trim();
  if (runtime && runtime.length > 0) {
    return normalizeUrl(runtime);
  }

  const configured = import.meta.env.VITE_API_URL?.trim();
  if (configured && configured.length > 0) {
    return normalizeUrl(configured);
  }

  return DEFAULT_API_URL;
}

export function getSentryDsn() {
  return window.__PADDIQ_CONFIG__?.sentryDsn?.trim()
    || import.meta.env.VITE_SENTRY_DSN?.trim()
    || DEFAULT_SENTRY_DSN;
}

export function getSentryEnvironment() {
  return window.__PADDIQ_CONFIG__?.sentryEnvironment?.trim() || import.meta.env.MODE;
}

export function appPath(path: string) {
  return `${getAppUrl()}${path.startsWith('/') ? path : `/${path}`}`;
}
